const callForContentConfig = {
  cfcTimezone: 'America/Denver',
  starts: '2026-05-19T09:00:00-06:00',
  ends: '2027-02-25T07:00:00.000Z',
  submissionEnds: '2026-06-29T23:59:59-06:00',
  approvalStarts: '2026-09-15T12:59:59-06:00',
  sessionsDue: '2026-12-08T23:59:59-07:00',
  syllabiAndSlidesDue: '2027-01-27T23:59:59-07:00',
  profilesCreationDeadlineTimestamp: '2027-02-06T07:00:00.000Z',
}

export default callForContentConfig
